import { Calendar } from 'owa-calendar-cache';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export const calendarSelected = action('calendarSelected', (calendar: Calendar) =>
    addDatapointConfig({ name: 'selectCalendarOnCalendarPicker' }, { calendar })
);

export const unauthorizedCalendarProviderCalendarSelected = action(
    'unauthorizedCalendarProviderCalendarSelected',
    (calendar: Calendar) => ({
        calendar,
    })
);
